export default __webpack_public_path__ + "static/media/administration.03edde0b.svg";